<!-- eslint-disable -->
<template lang="pug">
    .olympiad-preview(v-if="olympiads.length")
        olympiad-banner(v-for="olympiad in olympiads", :olympiad="olympiad", :key="olympiad.id")
    cs-loader(v-else-if="isLoading")
</template>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex'
    import moment from 'moment'
    import OlympiadApi from '../../../api/olympiad'
    import OlympiadBanner from './OlympiadBanner.vue'
    import PromoBanner from './PromoBanner.vue'

    export default {
        components: {
            PromoBanner,
            OlympiadBanner
        },
        data () {
            return {
                isAnimated: false,
                animateInterval: null,
                olympiads: [],
                isLoading: true
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user,
            })
        },
        mounted () {
            this.fetchData();
        },
        methods: {
            fetchData () {
                let request = {
                    date: moment().format('YYYY-MM-DD'),
                    status: 'archived',
                    statusOperator: '!=',
                    withoutCompleted: true
                };
                OlympiadApi.list(request)
                .then(olympiads => {
                    if (!olympiads || !olympiads.length) {
                        this.isLoading = false;
                        return;
                    }
                    olympiads.forEach(olympiad => {
                        olympiad.isRegistrationAllowed = olympiad.isRegistrationAllowed && !olympiad.authUserRegisteredLevel;
                    });
                    this.olympiads = _.sortBy(olympiads, 'authUserRegisteredLevel.secondsToStart');
                    this.isLoading = false;
                })
                .catch(error => {
                    this.isLoading = false;
                    if (error.data) {
                        this.$toasted.error(this.$root.$t(`errors.${error.data.message}`));
                    } else {
                        this.$toasted.error(this.$root.$t('errors.getting_olympiads'));
                    }
                });
            }
        }
    }
</script>

<style lang="scss" scoped>
    .olympiad-preview:not(:last-child) {
        margin-bottom: 30px;
    }
</style>
